// Environment Configuration Manager
// Easily switch between development and production environments

const environments = {
  development: {
    name: 'Development',
    backend: {
      url: 'http://localhost:5002',
      cors: ['http://localhost:3000', 'http://localhost:3001']
    },
    xumm: {
      network: 'wss://xrplcluster.com', // Testnet
      apiKey: process.env.REACT_APP_XUMM_API_KEY,
    },
    xrpl: {
      network: 'wss://xrplcluster.com', // Mainnet
      currency: '5847434C00000000000000000000000000000000',
      issuer: process.env.REACT_APP_XGC_ISSUER || 'rXGCL7F4P5tC2GnSDw9zsWpg663q29eeb',
      requiredAmount: 0
    },
    supabase: {
      url: process.env.REACT_APP_SUPABASE_URL,
      anonKey: process.env.REACT_APP_SUPABASE_ANON_KEY
    },
    features: {
      debugMode: true,
      analytics: false,
      errorReporting: false,
      logging: 'verbose'
    }
  },

  production: {
    name: 'Production',
    backend: {
      url: 'https://ignitabackend.onrender.com',
      cors: [
        'https://www.ignita-ai.io',
        'https://ignita-ai.io',
        'https://ignita-production.vercel.app',
        /^https:\/\/ignita-production.*\.vercel\.app$/,
        /^https:\/\/.*-dvl-test\.vercel\.app$/,
        /^https:\/\/.*\.ignita-ai\.io$/
      ]
    },
    xumm: {
      network: 'wss://xrplcluster.com', // Mainnet
      apiKey: process.env.REACT_APP_XUMM_API_KEY_PROD || process.env.REACT_APP_XUMM_API_KEY,
    },
    xrpl: {
      network: 'wss://xrplcluster.com', // Mainnet
      currency: '5847434C00000000000000000000000000000000',
      issuer: process.env.REACT_APP_XGC_ISSUER_PROD || process.env.REACT_APP_XGC_ISSUER,
      requiredAmount: 0
    },
    supabase: {
      url: process.env.REACT_APP_SUPABASE_URL_PROD || process.env.REACT_APP_SUPABASE_URL,
      anonKey: process.env.REACT_APP_SUPABASE_ANON_KEY_PROD || process.env.REACT_APP_SUPABASE_ANON_KEY
    },
    features: {
      debugMode: false,
      analytics: true,
      errorReporting: true,
      logging: 'error'
    }
  }
};

// Environment detection and selection
const getEnvironment = () => {
  // Check for explicit environment override
  const envOverride = process.env.REACT_APP_ENVIRONMENT;
  if (envOverride && environments[envOverride]) {
    console.log(`🔧 Environment override: ${envOverride}`);
    return environments[envOverride];
  }

  // Auto-detect based on various conditions
  const isLocalhost = window.location.hostname === 'localhost' || 
                     window.location.hostname === '127.0.0.1' ||
                     window.location.hostname.includes('local');
  
  const isDevelopment = process.env.NODE_ENV === 'development' || isLocalhost;
  
  const selectedEnv = isDevelopment ? 'development' : 'production';
  
  console.log(`🌍 Environment auto-detected: ${selectedEnv}`);
  console.log(`📍 Hostname: ${window.location.hostname}`);
  console.log(`🔧 NODE_ENV: ${process.env.NODE_ENV}`);
  
  return environments[selectedEnv];
};

// Get current environment configuration
export const getCurrentEnvironment = () => {
  const env = getEnvironment();

  return env;
};

// Environment-specific configuration getters
export const getBackendUrl = () => getCurrentEnvironment().backend.url;
export const getXrplNetwork = () => getCurrentEnvironment().xrpl.network;
export const getXummApiKey = () => getCurrentEnvironment().xumm.apiKey;
export const getSupabaseConfig = () => getCurrentEnvironment().supabase;
export const getFeatureFlags = () => getCurrentEnvironment().features;

// Utility function to check if we're in development
export const isDevelopment = () => getCurrentEnvironment().name === 'Development';
export const isProduction = () => getCurrentEnvironment().name === 'Production';

// Export the full configuration
export default getCurrentEnvironment();
